import { API_BASE_URL } from "@/config";
export default {
  name: "AddressDetails",
  props: {
    getSavedSectionResponses: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      // Original form fields
      client_physical_address_1: "",
      client_physical_address_2: "",
      client_physical_suburb: "",
      client_physical_city: "",
      client_physical_post_code: "",
      client_physical_province: "",
      client_physical_address_date: "",
      client_physical_country: "",
      client_residential_status: "",

      client_postal_address_1: "",
      client_postal_address_2: "",
      client_postal_suburb: "",
      client_postal_city: "",
      client_postal_post_code: "",
      client_postal_province: "",
      client_postal_country: "",

      same_as_physical: false,

      // Postal code search state
      physical_suburb_search: "",
      physical_postal_code_results: [],
      physical_show_dropdown: false,
      physical_search_loading: false,

      postal_suburb_search: "",
      postal_postal_code_results: [],
      postal_show_dropdown: false,
      postal_search_loading: false,

      questions: [],
      question_map: {},
      error_messages: {},
      province_options: [
        { value: "EASTERN CAPE", label: "Eastern Cape" },
        { value: "FREE STATE", label: "Free State" },
        { value: "GAUTENG", label: "Gauteng" },
        { value: "KWAZULU-NATAL", label: "KwaZulu-Natal" },
        { value: "LIMPOPO", label: "Limpopo" },
        { value: "MPUMALANGA", label: "Mpumalanga" },
        { value: "NORTHERN CAPE", label: "Northern Cape" },
        { value: "NORTH WEST", label: "North West" },
        { value: "WESTERN CAPE", label: "Western Cape" },
      ],
      country_options: [
        { value: "SOUTH AFRICA", label: "South Africa" },
        { value: "OTHER", label: "Other" },
      ],
      residential_status_options: [
        { value: "OWNER BONDED", label: "Owner Bonded" },
        { value: "OWNER BOND FREE", label: "Owner Bond Free" },
        { value: "TENANT", label: "Tenant" },
        { value: "BOARDER", label: "Boarder" },
      ],
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
  },
  watch: {
    same_as_physical(new_val) {
      if (new_val) {
        this.copy_physical_address();
      }
    },
    client_physical_address_1: "sync_postal_if_same",
    client_physical_address_2: "sync_postal_if_same",
    client_physical_suburb: "sync_postal_if_same",
    client_physical_city: "sync_postal_if_same",
    client_physical_post_code: "sync_postal_if_same",
    client_physical_province: "sync_postal_if_same",
    client_physical_country: "sync_postal_if_same",
  },
  methods: {
    sync_postal_if_same() {
      if (this.same_as_physical) {
        this.copy_physical_address();
      }
    },
    // Postal code search methods
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    search_physical_postal_codes() {
      const query = this.physical_suburb_search.trim();
      if (query.length < 2) {
        this.physical_postal_code_results = [];
        this.physical_show_dropdown = false;
        return;
      }

      this.physical_search_loading = true;
      const TOKEN = localStorage.getItem("token");
      const SEARCH_URL = `${API_BASE_URL}/verify_api/financial_information_api/search_postal_codes/?suburb=${encodeURIComponent(
        query
      )}&limit=20`;

      $.ajax({
        url: SEARCH_URL,
        method: "GET",
        headers: { Authorization: `Token ${TOKEN}` },
        success: (response) => {
          this.physical_postal_code_results = response.results || [];
          this.physical_show_dropdown =
            this.physical_postal_code_results.length > 0;
          this.physical_search_loading = false;
        },
        error: () => {
          this.physical_postal_code_results = [];
          this.physical_show_dropdown = false;
          this.physical_search_loading = false;
        },
      });
    },
    select_physical_postal_code(result) {
      this.client_physical_suburb = result.suburb;
      this.client_physical_post_code = result.postal_code;
      this.physical_suburb_search = result.suburb;
      this.physical_show_dropdown = false;
      this.physical_postal_code_results = [];
    },
    search_postal_postal_codes() {
      const query = this.postal_suburb_search.trim();
      if (query.length < 2) {
        this.postal_postal_code_results = [];
        this.postal_show_dropdown = false;
        return;
      }

      this.postal_search_loading = true;
      const TOKEN = localStorage.getItem("token");
      const SEARCH_URL = `${API_BASE_URL}/verify_api/financial_information_api/search_postal_codes/?suburb=${encodeURIComponent(
        query
      )}&limit=20`;

      $.ajax({
        url: SEARCH_URL,
        method: "GET",
        headers: { Authorization: `Token ${TOKEN}` },
        success: (response) => {
          this.postal_postal_code_results = response.results || [];
          this.postal_show_dropdown =
            this.postal_postal_code_results.length > 0;
          this.postal_search_loading = false;
        },
        error: () => {
          this.postal_postal_code_results = [];
          this.postal_show_dropdown = false;
          this.postal_search_loading = false;
        },
      });
    },
    select_postal_postal_code(result) {
      this.client_postal_suburb = result.suburb;
      this.client_postal_post_code = result.postal_code;
      this.postal_suburb_search = result.suburb;
      this.postal_show_dropdown = false;
      this.postal_postal_code_results = [];
    },
    hide_physical_dropdown() {
      setTimeout(() => {
        this.physical_show_dropdown = false;
      }, 200);
    },
    hide_postal_dropdown() {
      setTimeout(() => {
        this.postal_show_dropdown = false;
      }, 200);
    },
    get_questions() {
      const TOKEN = localStorage.getItem("token");
      const GET_QUESTIONS_URL = `${API_BASE_URL}/verify_api/financial_information_api/get_address_questions/`;

      $.ajax({
        url: GET_QUESTIONS_URL,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Fetching questions...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: (response) => {
          Swal.close();
          this.questions = response.questions;

          // Map each question's api_form_field to its id
          this.questions.forEach((question) => {
            if (question.api_form_field) {
              this.question_map[question.api_form_field] = question.id;
            }
          });

          this.load_saved_responses();
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to fetch questions. Please try again later.",
            confirmButtonText: "OK",
          });
        },
      });
    },
    copy_physical_address() {
      if (this.same_as_physical) {
        this.client_postal_address_1 = this.client_physical_address_1;
        this.client_postal_address_2 = this.client_physical_address_2;
        this.client_postal_suburb = this.client_physical_suburb;
        this.client_postal_city = this.client_physical_city;
        this.client_postal_post_code = this.client_physical_post_code;
        this.client_postal_province = this.client_physical_province;
        this.client_postal_country = this.client_physical_country;
        // Also copy the search field for display
        this.postal_suburb_search = this.physical_suburb_search;
      } else {
        this.client_postal_address_1 = "";
        this.client_postal_address_2 = "";
        this.client_postal_suburb = "";
        this.client_postal_city = "";
        this.client_postal_post_code = "";
        this.client_postal_province = "";
        this.client_postal_country = "";
        // Also clear the search field
        this.postal_suburb_search = "";
      }
    },

    validate_address_form() {
      this.error_messages = {}; // Reset errors

      // Validate each field based on question requirements
      this.questions.forEach((question) => {
        const field_name = question.api_form_field;
        if (!field_name) return; // Skip if no field mapping

        // Check if field is required and empty
        if (question.required && !this[field_name]) {
          this.error_messages[field_name] = `${question.question} is required.`;
        }
      });

      // Special case for postal address fields if not same as physical
      if (!this.same_as_physical) {
        const postal_fields = [
          "client_postal_address_1",
          "client_postal_address_2",
          "client_postal_suburb",
          "client_postal_city",
          "client_postal_post_code",
          "client_postal_province",
          "client_postal_country",
        ];

        postal_fields.forEach((field) => {
          if (!this[field] && this.question_map[field]) {
            const question = this.questions.find(
              (q) => q.id === this.question_map[field]
            );
            if (question && question.required) {
              this.error_messages[field] = `${question.question} is required.`;
            }
          }
        });
      }
      return Object.keys(this.error_messages).length === 0;
    },

    save_address_details(section = null, customer_id = null) {
      // Handle case where section is a DOM event (from template click)
      if (
        section &&
        (section instanceof Event || section.type === "click" || section.target)
      ) {
        section = null;
      }

      if (!section && !this.validate_address_form()) {
        console.error("Validation errors:", this.error_messages);
        Swal.fire({
          icon: "warning",
          title: "Incomplete Form",
          text: "Please complete all required fields before continuing.",
          confirmButtonText: "OK",
        });
        return;
      }

      const TOKEN = localStorage.getItem("token");
      const SAVE_RESPONSES_URL = `${API_BASE_URL}/verify_api/financial_information_api/save_address_details/`;

      // Prepare responses by mapping form values back to question_ids
      let responses = [];

      if (section && Array.isArray(section.questions)) {
        responses = section.questions.map((q) => ({
          question_id: q.question_id,
          answer: q.response?.toString() || "",
        }));
      } else {
        // Process each field in our data model
        Object.keys(this.$data).forEach((field_name) => {
          // Skip non-form fields or empty values
          if (
            !this.question_map[field_name] ||
            field_name === "questions" ||
            field_name === "question_map" ||
            field_name === "error_messages" ||
            field_name === "same_as_physical"
          ) {
            return;
          }

          // Add to responses array
          responses.push({
            question_id: this.question_map[field_name],
            answer: this[field_name] || "",
          });
        });
      }

      const FORM_DATA = {
        workflow_id: this.workflow_id,
        responses: responses,
      };

      if (customer_id) {
        FORM_DATA.customer_id = customer_id;
      }

      $.ajax({
        url: SAVE_RESPONSES_URL,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(FORM_DATA),
        beforeSend: () => {
          Swal.fire({
            text: "Saving address details...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: () => {
          Swal.close();
          if (section && customer_id) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Address details changed successfully!",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            this.$emit("validity-change", true);
          }
        },
        error: (xhr) => {
          Swal.close();
          let errorMessage =
            "Failed to save address details. Please try again later.";
          if (xhr.responseJSON && xhr.responseJSON.error) {
            errorMessage = xhr.responseJSON.error;
          }
          Swal.fire({
            icon: "error",
            title: "Error",
            text: errorMessage,
            confirmButtonText: "OK",
          });
        },
      });
    },
    async load_saved_responses() {
      try {
        const responses = await this.getSavedSectionResponses(
          "Address Details"
        );

        const idToField = {};
        Object.entries(this.question_map).forEach(([field, qid]) => {
          idToField[qid] = field;
        });

        if (Array.isArray(responses) && responses.length > 0) {
          responses.forEach((resp) => {
            const field = idToField[resp.question_id];
            if (field && Object.prototype.hasOwnProperty.call(this, field)) {
              this[field] = resp.answer;
            }
          });
          // Also set the search fields for suburb display
          if (this.client_physical_suburb) {
            this.physical_suburb_search = this.client_physical_suburb;
          }
          if (this.client_postal_suburb) {
            this.postal_suburb_search = this.client_postal_suburb;
          }
        }
      } catch (error) {
        console.error("Error loading saved responses:", error);
      }
    },
  },
  mounted() {
    if (this.$store.getters.get_user_role?.toLowerCase() === "customer") {
      this.get_questions();
    }
  },
};
